<template>
    <RgLimitsBar
        v-if="isRgLimitsBarVisible"
        @closeRgLimitsBar="closeRgLimitsBarHandler"
        @openRgLimitsBar="openRgLimitsBarHandler"
    />
</template>

<script setup lang="ts">
import RgLimitsBar from "@sazka/ng/rg-limits/rg-limits-bar.vue";
import { usePopupsSequence } from "@/shared/components/master-page/use-popups-sequence";

const { isRgLimitsBarVisible, isRgLimitsBarClosed, isLegalWarningVisible } = usePopupsSequence();

const closeRgLimitsBarHandler = () => {
    isRgLimitsBarClosed.value = true;
};

const openRgLimitsBarHandler = () => {
    isRgLimitsBarVisible.value = !isLegalWarningVisible.value;
};
</script>
